import { ComingSoon } from "@/components/common";

export function FaturamentoPage() {
  return <ComingSoon title="Faturamento" subtitle="Cobrança e recebíveis" icon="credit-card" />;
}
